import { useEffect, useState } from 'react'
import Modal from './Modal'

const ModalViewWithTabs: React.FC<ModalViewWithTabsProps> = ({
  dataWithTabs,
  tabSelected = -1,
  display,
  onClose,
  scroll = 'visible',
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(0)

  // const sampleData = [
  //   { title: 'Tab 1', data: 'abc' },
  //   {
  //     title: 'Tab 2',
  //     data: 'efg',
  //   },
  // ]
  useEffect(() => {
    if (tabSelected !== -1) setSelectedTab(tabSelected)
  }, [tabSelected])

  const handleClick = (i) => {
    setSelectedTab(i)
  }

  return (
    <Modal
      display={display}
      xlClasses="xl:w-2/6"
      onClose={() => {
        onClose()
        setSelectedTab(0)
      }}
      // scroll={scroll}
    >
      <div className="m-auto">
        <div className="flex flex-wrap rounded-lg bg-gray-100 divide-x-2 divide-gray-200 dark:bg-gray-800 m-auto mb-10">
          {dataWithTabs.map((tab, i) => (
            <div
              key={tab.title}
              className={`px-3 flex-grow transition-all py-2.5 flex items-center justify-center cursor-pointer ${
                selectedTab === i
                  ? 'bg-primaryGray-500 dark:bg-gray-600'
                  : 'bg-primary dark:bg-gray-900'
              }`}
              onClick={() => handleClick(i)}
            >
              <div className="h-full flex items-center">
                <span className="text-center">
                  {/* <Icon
              className={`${
                i === selected
                ? 'text-primary dark:text-white'
                : 'text-trueGray-600 dark:text-gray-300'
              } mr-3 z-20 text-lg`}
            /> */}
                </span>
                <p
                  className={`${
                    selectedTab === i
                      ? 'text-primary dark:text-white'
                      : 'text-trueGray-600 dark:text-gray-300'
                  }`}
                >
                  <b>{tab.title}</b>
                </p>
              </div>
            </div>
          ))}
        </div>
        <pre className="overflow-auto max-h-96">
          {dataWithTabs[selectedTab]?.data}
        </pre>
      </div>
    </Modal>
  )
}

export default ModalViewWithTabs

export interface DataTabView {
  title: string
  data: string
}

interface ModalViewWithTabsProps {
  dataWithTabs: DataTabView[]
  tabSelected?: number
  display: boolean
  onClose: Function
  scroll?: 'scroll' | 'visible'
}
